import { render, staticRenderFns } from "./GraphDetail23.vue?vue&type=template&id=6fe5be72&scoped=true&"
import script from "./GraphDetail23.vue?vue&type=script&lang=js&"
export * from "./GraphDetail23.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fe5be72",
  null
  
)

export default component.exports